require("bootstrap-cookie-alert");

$(document).ready(function($) {
  $('.cart-counter').filter(function() {
    return $(this).text().trim() !== '0';
  }).show();
});